import { useEffect } from "react";
import { useSettings } from "@/context/SettingsContext";
import { brandedSrc } from "@/lib/api";

/**
 * Keeps the browser tab favicon (and apple-touch icon) in sync with the
 * branding favicon configured in Admin → Settings. Updates instantly on save
 * because SettingsContext refetches and this effect re-runs. A cache-busting
 * version is baked into the href via brandedSrc so the tab never shows a stale
 * icon after a re-upload.
 */
export function BrandingHead() {
  const { settings } = useSettings();
  const faviconUrl = settings.faviconUrl;

  useEffect(() => {
    const ensure = (rel) => {
      let el = document.querySelector(`link[rel='${rel}']`);
      if (!el) {
        el = document.createElement("link");
        el.rel = rel;
        document.head.appendChild(el);
      }
      return el;
    };
    // Configured favicon → use it (cache-busted). Cleared → reset to default.
    const href = faviconUrl ? brandedSrc(faviconUrl) : `${process.env.PUBLIC_URL || ""}/favicon.ico`;
    ensure("icon").href = href;
    ensure("shortcut icon").href = href;
    ensure("apple-touch-icon").href = href;
  }, [faviconUrl]);

  return null;
}
